// Portal text in Swahili (sw) and English (en). Every key must exist in both languages:
// packages/shared/src/i18n.test.ts checks this. Use {name} for values filled in at run time.
//
// Two separate language choices exist:
//  - screen language: what the owner reads in the portal (header switch)
//  - ad language: what the ad itself says (chosen on "Eleza tangazo"); keys under ad.* follow it

export const LANGS = ['sw', 'en'] as const;
export type Lang = (typeof LANGS)[number];
export type Strings = Record<string, string | string[]>;

const sw: Strings = {
  'meta.title': 'Matangazo ya biashara yako | Tangazo',
  'meta.description': 'Tengeneza tangazo la picha au video kwa simu yako. Lipa kwa M-Pesa, Mixx by Yas, Airtel Money au HaloPesa.',
  'lang.name': 'Kiswahili',
  'lang.label': 'Lugha',
  progress: 'Hatua {n} kati ya {total}',
  wm: 'MFANO',

  'nav.back': 'Rudi',
  'nav.home': 'Mwanzo',
  'common.optional': '(si lazima)',
  'common.copied': 'Imenakiliwa',
  'common.retry': 'Jaribu tena',

  'footer.help': 'Msaada kwa WhatsApp',
  'footer.help_message': 'Habari, naomba msaada na tangazo langu {code}',
  'footer.payments': 'Lipa kwa M-Pesa, Mixx by Yas, Airtel Money au HaloPesa',

  'home.title': 'Tangazo la biashara yako, tayari kwa dakika chache',
  'home.lead': 'Weka picha za unachouza, andika maelezo machache. Tunaandika tangazo na kulipamba, tayari kwa WhatsApp Status, Instagram na Facebook.',
  'home.image': 'Tangazo la picha',
  'home.image_desc': 'Picha moja au zaidi zinageuka kuwa tangazo zuri.',
  'home.video': 'Tangazo la video',
  'home.video_desc': 'Video fupi ya sekunde 15 yenye sauti na muziki.',
  'home.from': 'Kuanzia {price}',
  'home.resume': 'Endelea na tangazo lako la mwisho',
  'home.how': 'Inavyofanya kazi',
  'home.step1': "Hadi picha 5 za bidhaa yako.",
  'home.step2': "Chagua mtindo na rangi.",
  'home.step3': "M-Pesa, Mixx, Airtel au HaloPesa.",
  'home.prices': 'Bei',
  'home.languages': 'Tangazo linaweza kuandikwa kwa Kiswahili au Kiingereza.',
  'land.eyebrow': 'Kwa wafanyabiashara wa Tanzania',
  'land.title_a': 'Tangazo linalouza,',
  'land.title_b': 'kwa dakika chache.',
  'land.lead': "Weka picha, andika maelezo machache. Tunatengeneza tangazo tayari kwa WhatsApp, Instagram na Facebook.",
  'land.cta': 'Tengeneza tangazo bure',
  'land.cta_video': 'Tangazo la video',
  'land.trust_free': "Angalia bure",
  'land.trust_pay': 'Lipa kwa simu',
  'land.trust_lang': 'Kiswahili au Kiingereza',
  'land.styles_title': "Mitindo 5. Rangi yoyote.",
  'land.styles_lead': 'Kila tangazo limepangwa vizuri: jina lako, bei na namba ya simu kama ulivyoandika.',
  'land.how_title': "Hatua tatu",
  'land.step1_t': 'Weka picha',
  'land.step2_t': 'Angalia bure',
  'land.step3_t': 'Lipa na pakua',
  'land.prices_title': 'Bei rahisi, bila usajili',
  'land.prices_lead': "Lipa kwa tangazo. Bila akaunti.",
  'land.choose': 'Anza',
  'land.faq_title': 'Maswali',
  'land.faq1_q': 'Je, naweza kuona tangazo kabla ya kulipa?',
  'land.faq1_a': 'Ndiyo. Unaona tangazo lako lote bure, lenye alama ya MFANO. Ukilipa, unapakua picha safi ya HD.',
  'land.faq2_q': 'Nalipaje?',
  'land.faq2_a': 'Kwa M-Pesa, Mixx by Yas, Airtel Money au HaloPesa. Utapokea ujumbe kwenye simu, unaweka PIN yako, basi.',
  'land.faq3_q': 'Maneno ya tangazo yanaandikwa na nani?',
  'land.faq3_a': 'Tunakuandikia machaguo matatu, na unaweza kubadilisha kila neno. Jina, bei na namba ya simu vinabaki kama ulivyoandika.',
  'land.faq4_q': 'Naweza kutumia tangazo wapi?',
  'land.faq4_a': 'WhatsApp Status, Instagram, Facebook, au kuchapisha. Picha Pro inakupa ukubwa wote 3.',
  'land.final_title': 'Tangazo lako lijalo liko dakika chache mbele.',
  'land.final_cta': 'Anza sasa',
  'land.sample_label': 'Mfano wa tangazo, mtindo {name}',
  'land.s1_business': 'Mama Neema Shoes',
  'land.s1_head': 'Viatu vipya vimefika',
  'land.s1_sub': 'Vya wanawake, saizi zote. Tunaleta mpaka nyumbani.',
  'land.s1_offer': 'Punguzo 10%',
  'land.s2_business': 'Juma Grill',
  'land.s2_head': 'Burger na soda',
  'land.s2_sub': 'Kila Ijumaa jioni, Sinza Mori.',
  'land.s2_offer': 'Ofa',
  'land.s3_business': "Bora Tailors",
  'land.s3_head': 'Mshono wa kisasa',
  'land.s3_sub': 'Vitenge, magauni na suti. Tayari kwa siku 3.',
  'land.s3_offer': 'Mpya',
  'land.s4_business': 'Glow Salon',
  'land.s4_head': 'Kucha nzuri, bei nzuri',
  'land.s4_sub': 'Gel, acrylic na pedicure. Weka nafasi leo.',
  'land.s4_offer': 'Mpya',
  'land.s5_business': 'Smart Simu TZ',
  'land.s5_head': 'Simu mpya, bei poa',
  'land.s5_sub': 'Original, na waranti ya mwaka mmoja.',
  'land.s5_offer': 'Imefika',
  'land.cta_word': 'Piga simu',

  'photos.title': 'Weka picha',
  'photos.lead': "Hadi picha {max}. Ya kwanza ndiyo kuu.",
  'photos.add': 'Ongeza picha',
  'photos.add_more': 'Ongeza nyingine',
  'photos.photo_n': 'Picha {n}',
  'photos.main': 'Kuu',
  'photos.make_main': 'Fanya kuu',
  'photos.remove': 'Ondoa',
  'photos.logo': 'Nembo ya biashara',
  'photos.add_logo': 'Ongeza nembo',
  'photos.logo_hint': "Inaonekana juu ya tangazo.",
  'photos.next': 'Endelea',

  'details.title': 'Eleza tangazo',
  'details.lead': 'Tuambie kidogo kuhusu biashara yako. Majina, bei na namba ya simu tutaziandika kama ulivyoandika wewe.',
  'details.category': 'Aina ya biashara',
  'details.business': 'Jina la biashara',
  'details.business_ph': 'Mf. Mama Neema Shoes',
  'details.offer': 'Unauza nini, au ofa yako ni ipi?',
  'details.offer_ph': 'Mf. Viatu vipya vya wanawake, punguzo 10%',
  'details.price': 'Bei',
  'details.price_ph': 'Mf. 35,000',
  'details.phone': 'Namba ya simu ya wateja',
  'details.phone_ph': 'Mf. 0712 345 678',
  'details.location': 'Mahali',
  'details.location_ph': 'Mf. Kariakoo, Dar es Salaam',
  'details.extra': 'Maelezo mengine',
  'details.extra_ph': 'Mf. Tunaleta mpaka nyumbani',
  'details.ad_lang': 'Lugha ya tangazo',
  'details.ad_lang_hint': 'Lugha ambayo wateja wako wataisoma kwenye tangazo.',
  'details.write': 'Andika tangazo',
  'details.continue': 'Endelea',
  'details.writing': 'Tunaandika…',

  'cat.mitindo': 'Nguo na viatu',
  'cat.chakula': 'Chakula na vinywaji',
  'cat.urembo': 'Urembo na saluni',
  'cat.simu': 'Simu na elektroniki',
  'cat.duka': 'Duka la bidhaa',
  'cat.huduma': 'Huduma',
  'cat.nyumba': 'Nyumba na viwanja',
  'cat.nyingine': 'Nyingine',

  'design.title': 'Tangazo lako',
  'design.prev': 'Mtindo uliopita',
  'design.next_style': 'Mtindo unaofuata',
  'design.preview_label': 'Mfano wa tangazo lako',
  'design.swipe': 'Telezesha kubadili mtindo',
  'design.watermark_note': "Mfano tu. Ukilipa, unapata HD safi bila \"{word}\".",
  'design.size': 'Ukubwa',
  'design.style': 'Mtindo wa tangazo',
  'design.after_pay': 'Chagua mtindo, ukubwa, rangi na maneno. Tangazo lako linatengenezwa baada ya kulipa.',
  'design.sample_note': 'Mifano hii inatumia picha za mfano, si yako.',
  'design.sizes_note': 'Picha Pro na kifurushi cha 5 vinakupa saizi zote 3.',
  'design.colour': 'Rangi',
  'design.text': 'Maneno',
  'design.option_n': 'Chaguo {n}',
  'design.edit': 'Badilisha maneno',
  'design.rewrite': 'Andika upya',
  'design.bank_note': 'Maneno haya yametoka kwenye maktaba yetu ya matangazo.',
  'design.f_headline': 'Kichwa',
  'design.f_subline': 'Mstari mfupi',
  'design.f_offer': 'Alama ya ofa',
  'design.f_cta': 'Mwito (mf. Agiza sasa)',
  'design.exact_note': 'Jina, bei na namba ya simu vinachukuliwa kama ulivyoandika.',
  'design.next': "Endelea",

  'tpl.bango': 'Bango',
  'tpl.ofa': 'Ofa',
  'tpl.kanga': 'Kanga',
  'tpl.safi': 'Safi',
  'tpl.usiku': 'Usiku',

  'fmt.status': 'Status',
  'fmt.post': 'Post',
  'fmt.square': 'Mraba',

  'video.title': 'Chagua video',
  'video.lead': "Tunatengeneza video kutoka picha zako.",
  'video.message': 'Ujumbe wa video',
  'video.notes': 'Maelekezo kwa mtengenezaji',
  'video.notes_ph': 'Mf. Muziki wa bongo flava, sauti ya kike',
  'video.next': 'Endelea kulipa',

  'script.title': 'Mpango wa video yako',
  'script.lead': 'Hivi ndivyo video itakavyokuwa, pamoja na maneno ya msimulizi. Hariri chochote, kisha thibitisha ili ulipe.',
  'script.writing': 'Tunaandika mpango wa video yako…',
  'script.summary': 'Maelezo ya video nzima',
  'script.scene': 'Sehemu {n}',
  'script.visual': 'Kinachoonekana',
  'script.voice': 'Sauti ya msimulizi',
  'script.text': 'Maandishi kwenye skrini',
  'script.seconds': 'Sauti: sekunde ~{n} kati ya {max}',
  'script.too_long': 'Maneno ya msimulizi ni mengi kuliko urefu wa video. Fupisha kidogo.',
  'script.edit': 'Hariri',
  'script.rewrite': 'Andika upya',
  'script.rewrite_sure': 'Mabadiliko yako yatafutwa. Uandike upya?',
  'script.add': 'Ongeza sehemu',
  'script.remove': 'Ondoa sehemu',
  'script.save': 'Hifadhi',
  'script.cancel': 'Ghairi',
  'script.confirm': 'Thibitisha mpango',
  'script.confirmed': 'Umethibitisha mpango huu. Video itatengenezwa kuufuata baada ya malipo.',

  'pay.title': 'Lipa',
  'pay.choose': 'Chagua kifurushi',
  'pay.preview_note': "Bila alama ya MFANO, ubora wa HD.",
  'pay.popular': 'Maarufu',
  'pay.phone': 'Namba itakayolipa',
  'pay.networks': 'M-Pesa, Mixx by Yas, Airtel Money au HaloPesa',
  'pay.button': 'Lipa {price}',
  'pay.sending': 'Tunatuma ombi…',
  'pay.how': "Utapokea ombi kwenye simu. Weka PIN.",
  'pay.have_voucher': 'Nina vocha',
  'pay.voucher_code': 'Namba ya vocha',
  'pay.use_voucher': 'Tumia vocha',
  'pay.failed': 'Malipo hayakukamilika.',
  'pay.reason.declined': 'Ombi lilikataliwa au PIN haikuwekwa. Jaribu tena.',
  'pay.reason.failed': 'Jaribu tena, au tumia namba nyingine.',
  'pay.reason.amount_mismatch': 'Kiasi kilicholipwa hakilingani. Wasiliana nasi.',
  'pay.reason.unknown_reference': 'Jaribu tena.',

  'product.image_one.name': 'Picha Moja',
  'product.image_one.short': 'Ukubwa 1',
  'product.image_one.features': ['Ukubwa 1 unaouchagua', 'Maneno ya tangazo', 'Maandishi madogo ya ads.m-changisha.online'],
  'product.image_pro.name': 'Picha Pro',
  'product.image_pro.short': 'Ukubwa wote 3',
  'product.image_pro.features': ['Ukubwa wote 3: Status, Post, Mraba', 'Picha inaboreshwa kwa AI', 'Bila maandishi yetu', 'Maelezo ya kuposti na hashtag'],
  'product.image_pack5.name': 'Kifurushi Pro 5',
  'product.image_pack5.short': 'Matangazo 5 ya Pro',
  'product.image_pack5.features': ['Lipia 4, la 5 ni bure', 'Tangazo hili la Pro', 'Vocha ya matangazo 4 zaidi, siku 60'],
  'product.video_photo.name': 'Video ya Picha',
  'product.video_photo.short': 'Sekunde 15',
  'product.video_photo.features': ['Picha zako zinachezeshwa', 'Sauti kwa lugha ya tangazo lako', 'Muziki'],
  'product.video_upgrade.name': 'Video ya Picha',
  'product.video_upgrade.short': 'Kutoka tangazo la picha',
  'product.video_upgrade.features': ['Picha na maneno yale yale', 'Sauti na muziki', 'Punguzo la 30%'],
  'product.video_hai.name': 'Video Hai',
  'product.video_hai.short': 'Sekunde 15',
  'product.video_hai.features': ['Picha zinageuka video halisi kwa AI', 'Sauti kwa lugha ya tangazo lako', 'Muziki'],

  'wait.title': 'Angalia simu yako',
  'wait.lead': 'Tumetuma ombi la kulipa {price} kwenda {phone}.',
  'wait.step1': 'Fungua ujumbe uliotokea kwenye simu.',
  'wait.step2': 'Weka PIN yako ya pesa kwa simu.',
  'wait.step3': 'Subiri hapa, tangazo lako litafunguka lenyewe.',
  'wait.mock': 'Hali ya majaribio: malipo yanakamilika yenyewe baada ya sekunde chache. Namba inayoishia 0000 inashindwa.',
  'wait.slow': 'Imechukua muda. Kama hukupata ujumbe, bonyeza "Tuma tena" au badilisha namba.',
  'wait.checking': 'Tunasubiri uthibitisho…',
  'wait.resend': 'Tuma tena',
  'wait.resent': 'Ombi limetumwa tena',
  'wait.change': 'Badilisha namba au kifurushi',

  'done.paid_title': 'Asante! Malipo yamepokelewa',
  'done.making': 'Tunatengeneza picha zako safi za HD…',
  'done.improving': 'Tunaboresha picha yako kwa AI. Inachukua hadi dakika moja…',
  'done.title': 'Tangazo lako liko tayari!',
  'done.lead': 'Namba ya oda: {code}',
  'done.download': 'Pakua',
  'done.share': 'Shiriki',
  'done.share_fallback': 'Simu hii haiwezi kushiriki moja kwa moja. Pakua picha, kisha iweke kwenye WhatsApp.',
  'done.photo_choice': 'Picha ya tangazo',
  'done.ai_photo': 'Iliyoboreshwa',
  'done.original_photo': 'Yangu ya asili',
  'done.caption': 'Maelezo ya kuposti',
  'done.copy_caption': 'Nakili maelezo',
  'done.voucher_title': 'Vocha yako ya matangazo 4',
  'done.voucher_body': 'Imebaki: matangazo {n} ya Pro. Inatumika mpaka {date}. Ingiza namba hii ukilipa tangazo lijalo.',
  'done.copy_voucher': 'Nakili vocha',
  'done.keep_link': 'Hifadhi kiungo hiki',
  'done.keep_link_body': 'Kwa kiungo hiki unaweza kupakua tangazo lako tena wakati wowote.',
  'done.copy_link': 'Nakili kiungo',
  'done.new': 'Tengeneza tangazo jipya',
  'done.cancelled': 'Oda hii imesitishwa',
  'done.cancelled_body': 'Kama una swali, wasiliana nasi kwa WhatsApp.',

  'upgrade.title': 'Ligeuze kuwa video',
  'upgrade.body': 'Video ya sekunde 15 kutoka picha na maneno haya, yenye sauti na muziki: {price} tu badala ya {was}.',
  'upgrade.button': 'Pata video kwa {price}',
  'upgrade.view': 'Angalia oda ya video',
  'upgrade.pay_title': 'Lipia video yako',

  'vdone.making_title': 'Tumepokea oda yako ya video',
  'vdone.making_body': 'Namba ya oda: {code}. Timu yetu inatengeneza video yako. Fungua kiungo hiki baadaye kuipakua.',
  'vdone.ready_title': 'Video yako iko tayari!',
  'vdone.back_to_image': 'Rudi kwenye tangazo la picha',

  "acct.signin": "Ingia",
  "acct.account": "Akaunti",
  "acct.phone_title": "Ingia kwa simu",
  "acct.phone_hint": "Tutakutumia SMS yenye namba 6.",
  "acct.phone_hint_mock": "SMS bado hazijawashwa.",
  "acct.code_mock": "Majaribio: andika {code}.",
  "acct.send": "Tuma namba",
  "acct.code_title": "Weka namba",
  "acct.code_sent": "Imetumwa kwa {phone}",
  "acct.verify": "Ingia",
  "acct.resend": "Tuma tena",
  "acct.resend_in": "Tuma tena baada ya sekunde {s}",
  "acct.change": "Badilisha namba",
  "acct.hello": "Habari, {name}",
  "acct.my_ads": "Matangazo yangu",
  "acct.new_ad": "Tangazo jipya",
  "acct.empty": "Bado huna tangazo.",
  "acct.logout": "Toka",
  "acct.name": "Jina lako",
  "acct.save": "Hifadhi",
  "acct.saved": "Imehifadhiwa",
  "acct.designer_title": "Mbunifu",
  "acct.designer_ask": "Tengeneza violezo, pata pointi.",
  "acct.designer_apply": "Omba kuwa mbunifu",
  "acct.designer_pending": "Ombi lako linakaguliwa.",
  "acct.designer_points": "Pointi zako: {n}",
  "acct.designer_soon": "Studio ya violezo inakuja hivi karibuni.",
  "acct.admin": "Admin",
  "st.draft": "Rasimu",
  "st.pending_payment": "Inasubiri malipo",
  "st.paid": "Imelipwa",
  "st.ready": "Tayari",
  "st.in_production": "Inatengenezwa",
  "st.cancelled": "Imesitishwa",
  "err.bad_code": "Namba si sahihi.",
  "err.code_expired": "Namba imeisha muda. Tuma mpya.",
  "err.wait": "Subiri kidogo kabla ya kutuma tena.",
  "err.sms_failed": "SMS haikutumwa. Jaribu tena.",
  "err.account_disabled": "Akaunti hii imezimwa.",
  "err.login_required": "Ingia kwanza.",
  "ai.title": "Miundo ya AI",
  "ai.left": "Zimebaki {n} kati ya {total}",
  "ai.original": "Picha yako",
  "ai.make": "Tengeneza mpya",
  "ai.none_left": "Umetumia miundo yote ya kifurushi hiki.",
  "ai.working": "Inatengenezwa…",
  "ai.failed": "Imeshindikana. Hukukatwa.",
  "ai.sandbox": "Majaribio",
  "ai.pick": "Gusa picha kuitumia kwenye tangazo.",
  "ai.style.studio": "Studio",
  "ai.style.lifestyle": "Maisha",
  "ai.style.street": "Mtaani",
  "ai.style.luxury": "Kifahari",
  "ai.style.bright": "Rangi",
  "ai.tokens_feature": "Miundo {n} ya AI",
  "ai.plan_feature": "Muundo {results} wa AI + mara {iterations} za kubadilisha kwa maelekezo yako",
  "err.no_tokens": "Umetumia miundo yote ya kifurushi hiki.",
  "err.busy": "Subiri muundo unaotengenezwa umalizike.",
  "err.not_paid": "Lipa kwanza ili kutumia AI.",
  "product.video_ai.name": "Video ya AI",
  "product.video_ai.short": "Video 3 za AI",
  "product.video_ai.features": ["Picha yako inageuka video kwa AI", "Matokeo 3 ya kuchagua", "Pakua MP4 papo hapo"],
  "nav.templates": "Violezo",
  "tg.title": "Violezo vya AI",
  "tg.lead": "Chagua mtindo, weka picha yako, AI inafanya mengine.",
  "tg.trending": "Vinavyovuma",
  "tg.all": "Vyote",
  "tg.kind_image": "Picha",
  "tg.kind_video": "Video",
  "tg.use": "Tumia kiolezo hiki",
  "tg.by": "Na {name}",
  "tg.team": "Timu ya Tangazo",
  "tg.uses": "{n} wametumia",
  "tg.needs": "Utahitaji",
  "tg.photos_n": "Picha {n}",
  "tg.examples": "Mifano",
  "tg.from": "Kuanzia {price}",
  "tg.rate": "Kadiria kiolezo hiki",
  "tg.rated": "Asante kwa kukadiria",
  "tg.empty": "Hakuna violezo hapa bado.",
  "tg.custom": "Tangazo la kawaida",
  "tg.custom_desc": "Mitindo 5, wewe unachagua kila kitu.",
  "land.templates_title": "Violezo vinavyovuma",
  "land.templates_all": "Ona vyote",
  "crop.title": "Kata picha",
  "crop.use": "Tumia",
  "crop.replace": "Badilisha",
  "crop.cancel": "Ghairi",
  "crop.zoom": "Kuza",
  "crop.rotate": "Zungusha",
  "crop.free": "Huru",
  "tf.details_title": "Maelezo machache",
  "tf.photo_hint": "Ushauri",
  "res.title": "Matokeo ya AI",
  "res.making": "AI inatengeneza… dakika 1 hadi 3.",
  "res.tweak": "Badilisha kidogo (si lazima)",
  "res.tweak_ph": "Mf. mandhari ya bluu",
  "res.again": "Tengeneza nyingine",
  "res.pick": "Gusa picha kuitumia kwenye tangazo.",
  "studio.title": "Studio ya mbunifu",
  "studio.new": "Kiolezo kipya",
  "studio.mine": "Violezo vyangu",
  "studio.points": "Pointi",
  "studio.empty": "Bado huna kiolezo.",
  "studio.not_designer": "Studio ni ya wabunifu. Omba kuwa mbunifu kwenye ukurasa wako.",
  "studio.st.draft": "Rasimu",
  "studio.st.pending": "Inakaguliwa",
  "studio.st.changes": "Rekebisha",
  "studio.st.approved": "Imeidhinishwa",
  "studio.st.rejected": "Imekataliwa",
  "studio.st.archived": "Imeondolewa",
  "studio.sec_basics": "Msingi",
  "studio.title_sw": "Jina (Kiswahili)",
  "studio.title_en": "Jina (Kiingereza)",
  "studio.desc_sw": "Maelezo (Kiswahili)",
  "studio.desc_en": "Maelezo (Kiingereza)",
  "studio.category": "Aina ya biashara",
  "studio.kind": "Aina ya tangazo",
  "studio.aspect": "Umbo",
  "studio.sec_ai": "Maelekezo kwa AI",
  "studio.model": "Modeli",
  "studio.prompt": "Maelekezo yako",
  "studio.prompt_hint": "Eleza mandhari, mwanga na mwendo wa kamera. Gusa sehemu kuziweka.",
  "studio.negative": "Epuka (si lazima)",
  "studio.duration": "Sekunde",
  "studio.audio": "Ongeza sauti",
  "studio.cost": "Gharama ya AI kwa tokeo moja: {usd}",
  "studio.sec_inputs": "Mteja ataleta nini",
  "studio.photos_min": "Picha, chini kabisa",
  "studio.photos_max": "Picha, zaidi kabisa",
  "studio.photo_hint_sw": "Ushauri wa picha (Kiswahili)",
  "studio.photo_hint_en": "Ushauri wa picha (Kiingereza)",
  "studio.core": "Taarifa za biashara",
  "studio.fields": "Maswali yako",
  "studio.add_field": "Ongeza swali",
  "studio.field_key": "Jina fupi (kwa maelekezo)",
  "studio.field_sw": "Swali (Kiswahili)",
  "studio.field_en": "Swali (Kiingereza)",
  "studio.required": "Lazima",
  "studio.sec_overlay": "Maandishi juu ya picha",
  "studio.overlay_none": "Hakuna, picha ya AI pekee",
  "studio.overlay_hint": "Jina, bei na simu huandikwa sawasawa kwa mpangilio huu.",
  "studio.accent": "Rangi",
  "studio.sec_media": "Picha za mfano",
  "studio.cover": "Picha kuu",
  "studio.examples": "Mifano (mitindo inayovuma)",
  "studio.upload": "Pakia",
  "studio.sec_test": "Jaribu",
  "studio.test_photo": "Weka picha ya kujaribu",
  "studio.run": "Jaribu sasa",
  "studio.tests_left": "Majaribio {n} yamebaki leo",
  "studio.add_example": "Weka kama mfano",
  "studio.sandbox_note": "Hali ya majaribio: tokeo ni picha yako tu.",
  "studio.save": "Hifadhi",
  "studio.submit": "Tuma kwa ukaguzi",
  "studio.saved": "Imehifadhiwa",
  "studio.submitted": "Imetumwa kwa ukaguzi",
  "studio.review_note": "Ujumbe wa mkaguzi",
  "studio.archive": "Ondoa kiolezo",
  "studio.ledger": "Historia ya pointi",
  "studio.sales": "Mauzo {n}",
  "studio.worth": "Takriban {tsh}",
  "pts.template_approved": "Kiolezo kimeidhinishwa",
  "pts.template_sale": "Mauzo ya kiolezo",
  "pts.payout": "Malipo",
  "pts.adjust": "Marekebisho",
  "err.template_not_found": "Kiolezo hiki hakipo.",
  "err.template_locked": "Kiolezo kinakaguliwa, hakiwezi kubadilishwa sasa.",
  "err.bad_placeholder": "Maelekezo yana sehemu isiyojulikana: {x}",
  "err.test_limit": "Umemaliza majaribio ya leo.",
  "err.cannot_rate_own": "Huwezi kukadiria kiolezo chako.",
  "err.missing_fields": "Jaza sehemu zote za lazima.",
  "err.forbidden": "Huna ruhusa.",
  "err.not_ready": "Kiolezo hakijakamilika: {x}",
  "err.service_paused": "Huduma hii imesimamishwa kwa muda. Jaribu tena baadaye.",
  'err.network': 'Hakuna mtandao. Angalia data yako kisha jaribu tena.',
  'err.server_error': 'Kuna tatizo upande wetu. Jaribu tena baada ya muda mfupi.',
  'err.order_not_found': 'Oda hii haipo. Angalia kiungo chako.',
  'err.photo_read': 'Picha hii haikusomeka. Jaribu picha nyingine.',
  'nav.create': "Tengeneza",
  'nav.discover': "Gundua",
  'nav.me': "Mimi",
  'disc.photo': "Picha AI",
  'disc.video': "Video",
  'disc.ad': "Tangazo",
  'disc.tools': "Vyote",
  'disc.new': "MPYA",
  'disc.make': "Tengeneza",
  'disc.make_video': "Tengeneza video",
  'disc.pick': "Chagua",
  'push.ready_title': "Tangazo: iko tayari!",
  'push.ready_body': "Picha yako imekamilika. Gusa hapa kuiona na kuipakua.",
  'push.preview_title': "Tangazo: hakiki picha ya kwanza",
  'push.preview_body': "Picha ya kwanza iko tayari. Gusa kuihakiki kisha endelea.",
  'push.failed_title': "Tangazo: imeshindikana",
  'push.failed_body': "Imeshindikana. Tokeni zako zimerudishwa.",
  'push.wait_title': "Tafadhali subiri, picha inatengenezwa…",
  'push.wait_body': "Inaweza kuchukua dakika chache. Unaweza kufunga ukurasa huu: tutakutumia taarifa ikiwa tayari.",
  'push.enable': "Nijulishe ikiwa tayari",
  'push.enabled': "Tutakujulisha ikiwa tayari",
  'push.denied': "Taarifa zimezuiwa kwenye kivinjari chako. Ziruhusu kwenye mipangilio ya tovuti.",
  'push.ios_hint': "Kwenye iPhone: bonyeza Share kisha \"Add to Home Screen\", fungua Tangazo kutoka hapo ili kupata taarifa.",
  'intro.purpose': "Unatengeneza nini?",
  'intro.tone': "Unataka iweje?",
  'intro.tone_hint': "Chagua moja, au ruka",
  'purpose.business': "Tangazo la biashara",
  'purpose.business_desc': "Bidhaa au huduma yako, na bei na namba ya simu",
  'purpose.meme': "Meme na burudani",
  'purpose.meme_desc': "Kitu cha kuchekesha cha kushiriki na marafiki",
  'purpose.personal': "Kwa ajili yangu",
  'purpose.personal_desc': "Picha au video yako, au ya kitu unachokipenda",
  'purpose.other': "Nyingine",
  'purpose.other_desc': "Chochote unachotaka kutengeneza",
  'tone.funny': "Ya kuchekesha",
  'tone.beautiful': "Ya kupendeza",
  'tone.dramatic': "Ya kusisimua",
  'tone.natural': "Ya kawaida",
  'create.what_ph_personal': "Eleza unachotaka, mf. paka wangu akiwa mfalme wa mtaa",
  'create.your_photo': "Picha yako",
  'pay.personal_note': "Picha yako inatengenezwa na AI baada ya kulipa.",
  'pay.free': 'Au tengeneza picha bure',
  'pay.free_note': 'polepole (dakika 2–5), ubora wa kawaida',
  'done.title_personal': "Picha yako iko tayari!",
  'intro.name': "Jina la biashara?",
  'intro.types': "Unafanya nini?",
  'intro.types_hint': "Chagua moja au zaidi",
  'intro.logo': "Una nembo?",
  'intro.logo_add': "Weka nembo",
  'intro.logo_hint': "Si lazima",
  'intro.step': "{n} kati ya {total}",
  'intro.contacts': "Namba ya simu?",
  'intro.contacts_hint': "Wateja watakupigia hapa",
  'create.product_photo': "Picha ya bidhaa",
  'create.what_ph': "Utengeneze nini? mf. Tangazo la viatu vipya",
  'ctx.add': "Ongeza maelezo",
  'ctx.add_more': "Ongeza jingine",
  'ctx.name_ph': "Jina, mf. Rangi",
  'ctx.value_ph': "Andika hapa",
  'ctx.remove': "Ondoa {name}",
  'ctx.ideas': "Mawazo",
  'ctx.save': "Weka",
  'ctx.cancel': "Acha",
  'create.login_title': "Ingia kwanza",
  'create.login_hint': "Tunahifadhi biashara na matangazo yako.",
  'create.close': "Funga",
  'create.title': "Tengeneza tangazo",
  'create.templates': "Au anza na kiolezo",
  'create.tab_image': "Picha",
  'create.tab_video': "Video",
  'create.tab_audio': "Sauti",
  'create.mode': "Tangazo jipya",
  'create.clear': "Anza upya",
  'create.clear_confirm': "Futa kila kitu na uanze upya?",
  'create.collapse': "Punguza",
  'create.expand': "Fungua",
  'create.add_photos': "Weka picha",
  'create.photos_hint': "Hadi picha {max}",
  'create.desc_label': "Maelezo",
  'create.desc_ph': "Eleza unachouza au ofa yako, mf. viatu vipya vya wanawake, saizi zote",
  'create.packages': "Vifurushi",
  'create.add_package': "Ongeza kifurushi",
  'create.pkg_name': "Jina la kifurushi",
  'create.pkg_name_ph': "mf. Jozi 2",
  'create.pkg_price': "Bei",
  'create.pkg_price_ph': "mf. 60,000",
  'create.pkg_desc': "Maelezo",
  'create.pkg_desc_ph': "mf. Kwa bei nafuu zaidi",
  'create.pkg_remove': "Ondoa kifurushi",
  'create.q_business': "Biashara yako inaitwaje?",
  'create.q_phone': "Wateja wakupigie namba gani?",
  'create.next': "Endelea",
  'create.skip': "Ruka",
  'create.edit': "Badilisha",
  'create.thinking': "AI inaangalia picha zako…",
  'create.need_photo_q': "Weka picha, AI itakuuliza maswali machache kuihusu.",
  'create.all_set': "Tayari! Bonyeza Tengeneza.",
  'create.quality': "Ubora",
  'create.q_standard': "Kawaida",
  'create.q_high': "Juu (2K)",
  'create.cost_1': "Tokeni 1 kwa picha",
  'create.cost_2': "Tokeni 2 kwa picha",
  'create.size': "Ukubwa",
  'create.model': "Modeli",
  'create.model_auto': "Bora zaidi (auto)",
  'create.video_type': "Aina ya video",
  'create.create': "Tengeneza",
  'create.creating': "Inaandika…",
  'create.tokens_est': "Takriban tokeni {n}",
  'create.tokens_note': "Tokeni zinatoka kwenye kifurushi utakacholipia. Kuandika maneno ni bure.",
  'create.audio_soon': "Matangazo ya sauti yanakuja hivi karibuni.",
  'create.need_photo': "Weka angalau picha moja.",
  'create.uploading': "Inapakia…",
  'err.need_business': 'Andika jina la biashara.',
  'err.need_offer': 'Andika unachouza au ofa yako.',
  'err.bad_phone': 'Andika namba sahihi ya simu, mf. 0712 345 678.',
  'err.missing_details': 'Jaza jina la biashara, unachouza na namba ya simu.',
  'err.no_photos': 'Ongeza angalau picha moja.',
  'err.too_large': 'Faili ni kubwa mno.',
  'err.not_an_image': 'Faili hili si picha. Tumia JPG, PNG au WebP.',
  'err.too_many': 'Majaribio mengi mno. Subiri kidogo kisha jaribu tena.',
  'err.free_limit': 'Umemaliza picha za bure za leo. Jaribu kesho, au lipia picha bora zaidi.',
  'err.free_unavailable': 'Picha za bure hazipatikani sasa hivi.',
  'err.locked': 'Oda hii imeshalipiwa na haiwezi kubadilishwa.',
  'err.already_paid': 'Oda hii imeshalipiwa.',
  'err.cancelled': 'Oda hii imesitishwa.',
  'err.bad_product': 'Chagua kifurushi.',
  'err.payment_unavailable': 'Malipo hayapatikani kwa sasa. Jaribu tena baada ya muda mfupi.',
  'err.no_pending_payment': 'Hakuna malipo yanayosubiri.',
  'err.voucher_not_found': 'Vocha hii haipo. Angalia namba.',
  'err.voucher_expired': 'Muda wa vocha hii umekwisha.',
  'err.voucher_used': 'Vocha hii imeshatumika yote.',
  'err.voucher_wrong_kind': 'Vocha hii ni ya matangazo ya picha tu.',
  'err.not_eligible': 'Hii haiwezekani kwa oda hii.',
  'err.script_needed': 'Thibitisha mpango wa video kwanza.',
  'err.script_empty': 'Andika maelezo ya video na angalau sehemu moja.',

  // Words printed on the ad itself: these follow the ad language, not the screen language.
  'ad.call': 'Piga',
  'ad.offer_word': 'Ofa',
  'ad.credit': 'Tangazo kupitia {site}',

  // Pricing v2: tokeni, wallet and the job flow (docs/TANGAZO_BUILD_SPEC.md §13).
  'v2.balance': 'Salio: tokeni {n}',
  'v2.buy_tokens': 'Nunua tokeni',
  'v2.price': 'Bei: tokeni {n} (Tsh {tzs})',
  'v2.price_from': 'kuanzia tokeni {n}',
  'v2.tokens': 'tokeni {n}',
  'v2.tsh': 'Tsh {tzs}',
  'v2.quality': 'Ubora',
  'v2.q.kawaida': 'Kawaida',
  'v2.q.hd': 'HD',
  'v2.q.premium': 'Premium',
  'v2.duration': 'Muda',
  'v2.seconds': 'sekunde {s}',
  'v2.addons': 'Ongeza',
  'v2.addon_price': '+ tokeni {n}',
  'v2.addon_free': 'bure kwa mpango wako',
  'v2.total': 'Jumla',
  'v2.use': 'Tumia template hii',
  'v2.free_badge': 'Marekebisho ya bure: {n}',
  'v2.upload': 'Pakia picha yako',
  'v2.upload_more': 'Picha {n} kati ya {max}',
  'v2.consent': 'Nathibitisha hii ni picha yangu au nina ruhusa ya kuitumia',
  'v2.script': 'Maandishi ya tangazo',
  'v2.script_hidden': 'Template hii inaandaa maandishi yenyewe.',
  'v2.final_prompt': 'Maelekezo kamili (Kiingereza)',
  'v2.improve': 'Boresha kwa AI (bure mara {n})',
  'v2.improve_paid': 'Boresha kwa AI (tokeni {n})',
  'v2.narration_count': 'sekunde ~{s} / {max}',
  'v2.next': 'Endelea',
  'v2.confirm': 'Thibitisha — tokeni {n} (Tsh {tzs})',
  'v2.promo': 'Una kodi ya ofa?',
  'v2.promo_apply': 'Tumia',
  'v2.generating': 'Inatengenezwa…',
  'v2.generating_step': 'Inatengeneza {step}…',
  'v2.step.first_frame': 'picha ya kwanza',
  'v2.step.video': 'video',
  'v2.step.image': 'picha',
  'v2.step.photos': 'picha',
  'v2.preview': 'Hakiki picha ya kwanza',
  'v2.preview_lead': 'Ukipenda picha hii, endelea na video. Usipoipenda, irekebishe.',
  'v2.continue_video': 'Endelea na video',
  'v2.free_iter': 'Marekebisho ya bure: {used} kati ya {total}',
  'v2.iterate_free': 'Rekebisha bure',
  'v2.retry': 'Jaribu tena — tokeni {n} (punguzo {pct}%)',
  'v2.iter_window': 'Unaweza kurekebisha hadi {time}',
  'v2.download': 'Pakua',
  'v2.share': 'Shiriki WhatsApp',
  'v2.sizes': 'Saizi nyingine',
  'v2.size.9:16': 'Status / Reels',
  'v2.size.1:1': 'Posti ya mraba',
  'v2.size.4:5': 'Posti ndefu',
  'v2.caption': 'Maelezo ya posti',
  'v2.copy': 'Nakili',
  'v2.short': 'Huna tokeni za kutosha. Unahitaji tokeni {n} zaidi.',
  'v2.pay_custom': 'Lipia Tsh {tzs} sasa (chenji: tokeni {n})',
  'v2.pay_pack': '{name}: tokeni {tokens} kwa Tsh {tzs}',
  'v2.better_value': 'Thamani bora',
  'v2.pay_phone': 'Namba ya simu ya kulipia',
  'v2.pay_wait': 'Thibitisha malipo kwenye simu yako. Tukipokea, tutaendelea wenyewe.',
  'v2.pay_done': 'Malipo yamepokelewa. Tokeni {n} zimeongezwa.',
  'v2.pay_failed': 'Malipo hayakukamilika. Jaribu tena.',
  'v2.expires': 'Zinaisha {date}',
  'v2.never_expires': 'Haziishi',
  'v2.failed': 'Imeshindikana. Tokeni zako zimerudishwa.',
  'v2.popular': 'Maarufu',
  'v2.watermark_note': 'Tokeni za bure zina alama ya Tangazo kwenye matokeo.',
  'v2.cancel': 'Sitisha',
  'v2.cancelled': 'Imesitishwa. Tokeni ambazo hazikutumika zimerudishwa.',
  'v2.abandoned': 'Muda umepita. Tokeni ambazo hazikutumika zimerudishwa.',
  'v2.state.draft': 'Rasimu',
  'v2.state.quoted': 'Inasubiri malipo',
  'v2.state.held': 'Imeanza',
  'v2.state.running': 'Inatengenezwa',
  'v2.state.awaiting_approval': 'Hakiki',
  'v2.state.succeeded': 'Tayari',
  'v2.state.failed': 'Imeshindikana',
  'v2.state.cancelled': 'Imesitishwa',
  'v2.state.abandoned': 'Imeachwa',
  'v2.login_first': 'Ingia kwanza ili kutumia tokeni.',
  'v2.sandbox': 'Majaribio: matokeo ni picha yako mwenyewe.',

  'wallet.title': 'Tokeni zangu',
  'wallet.lots': 'Tokeni zako',
  'wallet.lot': 'tokeni {n} · {when}',
  'wallet.held': 'tokeni {n} zinatumika sasa',
  'wallet.expiring': 'tokeni {n} zinaisha karibuni',
  'wallet.history': 'Historia',
  'wallet.packs': 'Vifurushi vya tokeni',
  'wallet.pack_line': 'tokeni {tokens} · siku {days}',
  'wallet.bonus': '+{pct}% bonasi',
  'wallet.buy': 'Nunua',
  'wallet.plans': 'Mipango ya biashara',
  'wallet.plan_line': 'tokeni {tokens} kila mwezi · Tsh {tzs}/mwezi',
  'wallet.plan_active': 'Mpango wako: {name} · hadi {date}',
  'wallet.plan_grace': 'Mpango wako umeisha. Lipia kabla ya {date} ili kuendelea.',
  'wallet.subscribe': 'Jiunge',
  'wallet.feature.brand_kit': 'Nembo na taarifa za biashara kwenye kila tangazo',
  'wallet.feature.captions_free': 'Maelezo ya posti bure',
  'wallet.feature.extra_sizes_free': 'Saizi za ziada bure',
  'wallet.feature.priority_queue': 'Kipaumbele kwenye foleni',
  'wallet.feature.client_folders': 'Folda za wateja',
  'wallet.feature.white_label': 'Nembo yako badala ya Tangazo',
  'wallet.brand': 'Taarifa za biashara (brand kit)',
  'wallet.brand_name': 'Jina la biashara',
  'wallet.brand_phone': 'Namba ya simu',
  'wallet.brand_location': 'Mahali',
  'wallet.brand_saved': 'Imehifadhiwa',
  'wallet.referral': 'Alika rafiki',
  'wallet.referral_lead': 'Rafiki akinunua tokeni za Tsh {min} au zaidi mara ya kwanza, nyote mnapata tokeni {n}.',
  'wallet.referral_stats': 'Umealika {invited} · wamelipa {rewarded}',
  'wallet.referral_share': 'Jiunge na Tangazo, utengeneze matangazo kwa simu: {link}',
  'wallet.l.credit': 'Umeongeza',
  'wallet.l.hold': 'Imetengwa kwa tangazo',
  'wallet.l.capture': 'Imetumika',
  'wallet.l.release': 'Imerudishwa',
  'wallet.l.expire': 'Imeisha muda',
  'wallet.l.adjust': 'Marekebisho',
  'wallet.src.pack': 'Kifurushi',
  'wallet.src.plan': 'Mpango',
  'wallet.src.custom_topup': 'Malipo',
  'wallet.src.signup_bonus': 'Zawadi ya kujiunga',
  'wallet.src.referral': 'Zawadi ya kualika',
  'wallet.src.promo': 'Ofa',
  'wallet.src.legacy': 'Salio la zamani',
  'wallet.src.adjust': 'Marekebisho',
  'wallet.empty': 'Bado huna tokeni.',

  'err.insufficient_tokens': 'Huna tokeni za kutosha.',
  'err.feature_off': 'Huduma hii bado haijawashwa.',
  'err.job_not_found': 'Tangazo hili halipo.',
  'err.consent_required': 'Thibitisha kuwa una ruhusa ya kutumia picha hii.',
  'err.content_blocked': 'Hatuwezi kutengeneza hili. Badilisha maelezo au picha. Hujatozwa tokeni.',
  'err.price_changed': 'Bei imebadilika. Angalia bei mpya kisha thibitisha tena.',
  'err.quote_expired': 'Bei imepitwa na muda. Thibitisha tena.',
  'err.bad_quote': 'Bei si sahihi. Jaribu tena.',
  'err.requote': 'Maandishi yamebadilika. Angalia bei mpya kisha thibitisha.',
  'err.not_awaiting_approval': 'Hatua hii haisubiri uthibitisho.',
  'err.not_iterable': 'Hii haiwezi kurekebishwa sasa.',
  'err.iteration_window_over': 'Muda wa kurekebisha umeisha.',
  'err.retry_payment_required': 'Marekebisho ya bure yamekwisha.',
  'err.promo_invalid': 'Kodi hii ya ofa haifanyi kazi.',
  'err.promo_used': 'Kodi hii ya ofa imeshatumika.',
  'err.promo_wrong_kind': 'Kodi hii ni ya huduma nyingine.',
  'err.promo_first_video_only': 'Ofa hii ni ya video yako ya kwanza tu.',
  'err.pack_not_found': 'Kifurushi hiki hakipo.',
  'err.plan_not_found': 'Mpango huu haupo.',
  'err.bad_amount': 'Chagua kiasi.',
  'err.use_tokens': 'Tangazo hili linalipiwa kwa tokeni.',
  'err.cannot_cancel': 'Haliwezi kusitishwa sasa.',
  'err.empty_field': 'Andika kitu kwanza.',
  'err.bad_field': 'Sehemu hii haiwezi kuboreshwa.',
  'err.ai_unavailable': 'AI haipatikani sasa. Jaribu tena baadaye.',
  'err.bad_output': 'Chagua picha.',
  'err.unknown_quality': 'Chagua ubora.',
  'err.bad_duration': 'Chagua muda.',
  'err.addon_not_allowed': 'Nyongeza hii haipatikani kwa template hii.',
  'err.unavailable': 'Template hii haipatikani kwa sasa.',
};

const en: Strings = {
  'meta.title': 'Ads for your business | Tangazo',
  'meta.description': 'Make an image or video ad on your phone. Pay with M-Pesa, Mixx by Yas, Airtel Money or HaloPesa.',
  'lang.name': 'English',
  'lang.label': 'Language',
  progress: 'Step {n} of {total}',
  wm: 'SAMPLE',

  'nav.back': 'Back',
  'nav.home': 'Home',
  'common.optional': '(optional)',
  'common.copied': 'Copied',
  'common.retry': 'Try again',

  'footer.help': 'Help on WhatsApp',
  'footer.help_message': 'Hello, I need help with my ad {code}',
  'footer.payments': 'Pay with M-Pesa, Mixx by Yas, Airtel Money or HaloPesa',

  'home.title': 'An ad for your business, ready in minutes',
  'home.lead': 'Add photos of what you sell and type a few details. We write the ad and design it, ready for WhatsApp Status, Instagram and Facebook.',
  'home.image': 'Image ad',
  'home.image_desc': 'One or more photos turned into a finished ad.',
  'home.video': 'Video ad',
  'home.video_desc': 'A short 15-second video with voice-over and music.',
  'home.from': 'From {price}',
  'home.resume': 'Continue your last ad',
  'home.how': 'How it works',
  'home.step1': "Up to 5 photos of what you sell.",
  'home.step2': "Pick a style and colour.",
  'home.step3': "M-Pesa, Mixx, Airtel or HaloPesa.",
  'home.prices': 'Prices',
  'home.languages': 'Your ad can be written in Swahili or English.',
  'land.eyebrow': 'For Tanzanian businesses',
  'land.title_a': 'Ads that sell,',
  'land.title_b': 'made in minutes.',
  'land.lead': "Add a photo and a few details. We make the ad, ready for WhatsApp, Instagram and Facebook.",
  'land.cta': 'Make an ad for free',
  'land.cta_video': 'Video ad',
  'land.trust_free': "Free preview",
  'land.trust_pay': 'Pay by phone',
  'land.trust_lang': 'Swahili or English',
  'land.styles_title': "5 styles. Any colour.",
  'land.styles_lead': 'Every ad is neatly laid out: your name, price and phone number exactly as you typed them.',
  'land.how_title': "Three steps",
  'land.step1_t': 'Add photos',
  'land.step2_t': 'Preview free',
  'land.step3_t': 'Pay and download',
  'land.prices_title': 'Simple prices, no sign-up',
  'land.prices_lead': "Pay per ad. No account.",
  'land.choose': 'Start',
  'land.faq_title': 'Questions',
  'land.faq1_q': 'Can I see the ad before I pay?',
  'land.faq1_a': 'Yes. You see the whole ad for free, with a SAMPLE mark. Once you pay, you download the clean HD image.',
  'land.faq2_q': 'How do I pay?',
  'land.faq2_a': 'With M-Pesa, Mixx by Yas, Airtel Money or HaloPesa. You get a prompt on your phone, enter your PIN, and that is it.',
  'land.faq3_q': 'Who writes the words?',
  'land.faq3_a': 'We write three options for you, and you can change every word. Your name, price and phone number stay exactly as you typed them.',
  'land.faq4_q': 'Where can I use the ad?',
  'land.faq4_a': 'WhatsApp Status, Instagram, Facebook, or print. Picha Pro gives you all 3 sizes.',
  'land.final_title': 'Your next ad is a few minutes away.',
  'land.final_cta': 'Start now',
  'land.sample_label': 'Sample ad, {name} style',
  'land.s1_business': 'Mama Neema Shoes',
  'land.s1_head': 'New shoes just arrived',
  'land.s1_sub': "Women's, all sizes. We deliver to your door.",
  'land.s1_offer': '10% off',
  'land.s2_business': 'Juma Grill',
  'land.s2_head': 'Burger and soda',
  'land.s2_sub': 'Every Friday evening, Sinza Mori.',
  'land.s2_offer': 'Deal',
  'land.s3_business': "Bora Tailors",
  'land.s3_head': 'Modern tailoring',
  'land.s3_sub': 'Vitenge, dresses and suits. Ready in 3 days.',
  'land.s3_offer': 'New',
  'land.s4_business': 'Glow Salon',
  'land.s4_head': 'Great nails, fair prices',
  'land.s4_sub': 'Gel, acrylic and pedicure. Book today.',
  'land.s4_offer': 'New',
  'land.s5_business': 'Smart Simu TZ',
  'land.s5_head': 'New phones, good prices',
  'land.s5_sub': 'Original, with a one-year warranty.',
  'land.s5_offer': 'In stock',
  'land.cta_word': 'Call',

  'photos.title': 'Add photos',
  'photos.lead': "Up to {max} photos. The first is the main one.",
  'photos.add': 'Add photos',
  'photos.add_more': 'Add another',
  'photos.photo_n': 'Photo {n}',
  'photos.main': 'Main',
  'photos.make_main': 'Make main',
  'photos.remove': 'Remove',
  'photos.logo': 'Business logo',
  'photos.add_logo': 'Add logo',
  'photos.logo_hint': "Shown at the top of the ad.",
  'photos.next': 'Continue',

  'details.title': 'Describe your ad',
  'details.lead': 'Tell us a little about your business. Names, prices and phone numbers appear exactly as you type them.',
  'details.category': 'Type of business',
  'details.business': 'Business name',
  'details.business_ph': 'e.g. Mama Neema Shoes',
  'details.offer': 'What do you sell, or what is your offer?',
  'details.offer_ph': 'e.g. New women\'s shoes, 10% off',
  'details.price': 'Price',
  'details.price_ph': 'e.g. 35,000',
  'details.phone': 'Phone number for customers',
  'details.phone_ph': 'e.g. 0712 345 678',
  'details.location': 'Location',
  'details.location_ph': 'e.g. Kariakoo, Dar es Salaam',
  'details.extra': 'Anything else',
  'details.extra_ph': 'e.g. We deliver to your home',
  'details.ad_lang': 'Language of the ad',
  'details.ad_lang_hint': 'The language your customers will read on the ad.',
  'details.write': 'Write my ad',
  'details.continue': 'Continue',
  'details.writing': 'Writing…',

  'cat.mitindo': 'Clothes and shoes',
  'cat.chakula': 'Food and drinks',
  'cat.urembo': 'Beauty and salon',
  'cat.simu': 'Phones and electronics',
  'cat.duka': 'Shop',
  'cat.huduma': 'Services',
  'cat.nyumba': 'Houses and land',
  'cat.nyingine': 'Other',

  'design.title': 'Your ad',
  'design.prev': 'Previous style',
  'design.next_style': 'Next style',
  'design.preview_label': 'Preview of your ad',
  'design.swipe': 'Swipe to change style',
  'design.watermark_note': "Preview only. Pay to get clean HD without \"{word}\".",
  'design.size': 'Size',
  'design.style': 'Ad style',
  'design.after_pay': 'Pick a style, size, colour and words. Your ad is made after you pay.',
  'design.sample_note': 'These examples use sample photos, not yours.',
  'design.sizes_note': 'Picha Pro and the 5-pack give you all 3 sizes.',
  'design.colour': 'Colour',
  'design.text': 'Text',
  'design.option_n': 'Option {n}',
  'design.edit': 'Edit the words',
  'design.rewrite': 'Write again',
  'design.bank_note': 'This text comes from our library of ad phrases.',
  'design.f_headline': 'Headline',
  'design.f_subline': 'Short line',
  'design.f_offer': 'Offer badge',
  'design.f_cta': 'Call to action (e.g. Order now)',
  'design.exact_note': 'Your name, price and phone number are used exactly as you typed them.',
  'design.next': "Continue",

  'tpl.bango': 'Bango (poster)',
  'tpl.ofa': 'Ofa (sale)',
  'tpl.kanga': 'Kanga',
  'tpl.safi': 'Safi (clean)',
  'tpl.usiku': 'Usiku (night)',

  'fmt.status': 'Status',
  'fmt.post': 'Post',
  'fmt.square': 'Square',

  'video.title': 'Choose your video',
  'video.lead': "We make the video from your photos.",
  'video.message': 'Video message',
  'video.notes': 'Notes for the video maker',
  'video.notes_ph': 'e.g. Bongo flava music, female voice',
  'video.next': 'Continue to payment',

  'script.title': 'Your video plan',
  'script.lead': 'This is what the video will be, with the narrator’s words. Edit anything, then confirm to pay.',
  'script.writing': 'Writing your video plan…',
  'script.summary': 'The whole video',
  'script.scene': 'Scene {n}',
  'script.visual': 'On screen',
  'script.voice': 'Narrator',
  'script.text': 'Words on screen',
  'script.seconds': 'Voice: ~{n} of {max} seconds',
  'script.too_long': 'The narration is longer than the video. Shorten it a little.',
  'script.edit': 'Edit',
  'script.rewrite': 'Write again',
  'script.rewrite_sure': 'Your changes will be lost. Write it again?',
  'script.add': 'Add a scene',
  'script.remove': 'Remove scene',
  'script.save': 'Save',
  'script.cancel': 'Cancel',
  'script.confirm': 'Confirm the plan',
  'script.confirmed': 'You confirmed this plan. The video is made from it after payment.',

  'pay.title': 'Pay',
  'pay.choose': 'Choose a package',
  'pay.preview_note': "HD, without the SAMPLE mark.",
  'pay.popular': 'Popular',
  'pay.phone': 'Number that will pay',
  'pay.networks': 'M-Pesa, Mixx by Yas, Airtel Money or HaloPesa',
  'pay.button': 'Pay {price}',
  'pay.sending': 'Sending request…',
  'pay.how': "You'll get a prompt on your phone. Enter your PIN.",
  'pay.have_voucher': 'I have a voucher',
  'pay.voucher_code': 'Voucher code',
  'pay.use_voucher': 'Use voucher',
  'pay.failed': 'The payment did not go through.',
  'pay.reason.declined': 'The request was declined or no PIN was entered. Please try again.',
  'pay.reason.failed': 'Try again, or use another number.',
  'pay.reason.amount_mismatch': 'The amount paid does not match. Please contact us.',
  'pay.reason.unknown_reference': 'Please try again.',

  'product.image_one.name': 'Picha Moja',
  'product.image_one.short': '1 size',
  'product.image_one.features': ['1 size of your choice', 'Ad text written for you', 'Small ads.m-changisha.online credit'],
  'product.image_pro.name': 'Picha Pro',
  'product.image_pro.short': 'All 3 sizes',
  'product.image_pro.features': ['All 3 sizes: Status, Post, Square', 'Photo improved by AI', 'No credit line', 'Post caption and hashtags'],
  'product.image_pack5.name': 'Kifurushi Pro 5',
  'product.image_pack5.short': '5 Pro ads',
  'product.image_pack5.features': ['Pay for 4, get the 5th free', 'This Pro ad', 'Voucher for 4 more ads, valid 60 days'],
  'product.video_photo.name': 'Video ya Picha',
  'product.video_photo.short': '15 seconds',
  'product.video_photo.features': ['Your photos animated', 'Voice-over in your ad\'s language', 'Music'],
  'product.video_upgrade.name': 'Video ya Picha',
  'product.video_upgrade.short': 'From your image ad',
  'product.video_upgrade.features': ['Same photos and text', 'Voice-over and music', '30% off'],
  'product.video_hai.name': 'Video Hai',
  'product.video_hai.short': '15 seconds',
  'product.video_hai.features': ['Photos turned into real AI video clips', 'Voice-over in your ad\'s language', 'Music'],

  'wait.title': 'Check your phone',
  'wait.lead': 'We sent a request to pay {price} to {phone}.',
  'wait.step1': 'Open the prompt that appeared on your phone.',
  'wait.step2': 'Enter your mobile money PIN.',
  'wait.step3': 'Wait here; your ad opens by itself.',
  'wait.mock': 'Test mode: payments complete by themselves after a few seconds. A number ending in 0000 fails.',
  'wait.slow': 'This is taking a while. If no prompt came, tap "Send again" or change the number.',
  'wait.checking': 'Waiting for confirmation…',
  'wait.resend': 'Send again',
  'wait.resent': 'Request sent again',
  'wait.change': 'Change number or package',

  'done.paid_title': 'Thank you! Payment received',
  'done.making': 'Making your clean HD images…',
  'done.improving': 'Improving your photo with AI. This takes up to a minute…',
  'done.title': 'Your ad is ready!',
  'done.lead': 'Order number: {code}',
  'done.download': 'Download',
  'done.share': 'Share',
  'done.share_fallback': 'This phone cannot share directly. Download the image, then add it in WhatsApp.',
  'done.photo_choice': 'Photo on the ad',
  'done.ai_photo': 'Improved',
  'done.original_photo': 'My original',
  'done.caption': 'Caption for your post',
  'done.copy_caption': 'Copy caption',
  'done.voucher_title': 'Your voucher for 4 ads',
  'done.voucher_body': 'Left: {n} Pro ads. Valid until {date}. Enter this code when you pay for your next ad.',
  'done.copy_voucher': 'Copy voucher',
  'done.keep_link': 'Keep this link',
  'done.keep_link_body': 'With this link you can download your ad again at any time.',
  'done.copy_link': 'Copy link',
  'done.new': 'Make a new ad',
  'done.cancelled': 'This order was cancelled',
  'done.cancelled_body': 'If you have a question, contact us on WhatsApp.',

  'upgrade.title': 'Turn it into a video',
  'upgrade.body': 'A 15-second video from these photos and words, with voice-over and music: only {price} instead of {was}.',
  'upgrade.button': 'Get the video for {price}',
  'upgrade.view': 'See your video order',
  'upgrade.pay_title': 'Pay for your video',

  'vdone.making_title': 'We have your video order',
  'vdone.making_body': 'Order number: {code}. Our team is making your video. Open this link later to download it.',
  'vdone.ready_title': 'Your video is ready!',
  'vdone.back_to_image': 'Back to your image ad',

  "acct.signin": "Sign in",
  "acct.account": "Account",
  "acct.phone_title": "Sign in with your phone",
  "acct.phone_hint": "We'll text you a 6-digit code.",
  "acct.phone_hint_mock": "SMS is not switched on yet.",
  "acct.code_mock": "Test mode: enter {code}.",
  "acct.send": "Send code",
  "acct.code_title": "Enter the code",
  "acct.code_sent": "Sent to {phone}",
  "acct.verify": "Sign in",
  "acct.resend": "Send again",
  "acct.resend_in": "Send again in {s}s",
  "acct.change": "Change number",
  "acct.hello": "Hi, {name}",
  "acct.my_ads": "My ads",
  "acct.new_ad": "New ad",
  "acct.empty": "No ads yet.",
  "acct.logout": "Sign out",
  "acct.name": "Your name",
  "acct.save": "Save",
  "acct.saved": "Saved",
  "acct.designer_title": "Designer",
  "acct.designer_ask": "Make templates, earn points.",
  "acct.designer_apply": "Apply as a designer",
  "acct.designer_pending": "Your request is being reviewed.",
  "acct.designer_points": "Your points: {n}",
  "acct.designer_soon": "The template studio is coming soon.",
  "acct.admin": "Admin",
  "st.draft": "Draft",
  "st.pending_payment": "Awaiting payment",
  "st.paid": "Paid",
  "st.ready": "Ready",
  "st.in_production": "In production",
  "st.cancelled": "Cancelled",
  "err.bad_code": "Wrong code.",
  "err.code_expired": "The code expired. Send a new one.",
  "err.wait": "Wait a moment before sending again.",
  "err.sms_failed": "The SMS couldn't be sent. Try again.",
  "err.account_disabled": "This account is disabled.",
  "err.login_required": "Please sign in first.",
  "ai.title": "AI designs",
  "ai.left": "{n} of {total} left",
  "ai.original": "Your photo",
  "ai.make": "Make a new one",
  "ai.none_left": "You've used every design in this package.",
  "ai.working": "Making…",
  "ai.failed": "Failed. Not counted.",
  "ai.sandbox": "Test",
  "ai.pick": "Tap a picture to use it in your ad.",
  "ai.style.studio": "Studio",
  "ai.style.lifestyle": "Lifestyle",
  "ai.style.street": "Street",
  "ai.style.luxury": "Luxury",
  "ai.style.bright": "Bright",
  "ai.tokens_feature": "{n} AI designs",
  "ai.plan_feature": "{results} AI result + {iterations} more with your own changes",
  "err.no_tokens": "You've used every design in this package.",
  "err.busy": "Wait for the current design to finish.",
  "err.not_paid": "Pay first to use AI.",
  "product.video_ai.name": "AI video",
  "product.video_ai.short": "3 AI videos",
  "product.video_ai.features": ["Your photo becomes a video with AI", "3 results to choose from", "Download the MP4 right away"],
  "nav.templates": "Templates",
  "tg.title": "AI templates",
  "tg.lead": "Pick a style, add your photo, AI does the rest.",
  "tg.trending": "Trending",
  "tg.all": "All",
  "tg.kind_image": "Image",
  "tg.kind_video": "Video",
  "tg.use": "Use this template",
  "tg.by": "By {name}",
  "tg.team": "Tangazo team",
  "tg.uses": "{n} uses",
  "tg.needs": "You need",
  "tg.photos_n": "{n} photo(s)",
  "tg.examples": "Examples",
  "tg.from": "From {price}",
  "tg.rate": "Rate this template",
  "tg.rated": "Thanks for rating",
  "tg.empty": "No templates here yet.",
  "tg.custom": "Classic ad",
  "tg.custom_desc": "5 layouts, you choose everything.",
  "land.templates_title": "Trending templates",
  "land.templates_all": "See all",
  "crop.title": "Crop the photo",
  "crop.use": "Use",
  "crop.replace": "Replace",
  "crop.cancel": "Cancel",
  "crop.zoom": "Zoom",
  "crop.rotate": "Rotate",
  "crop.free": "Free",
  "tf.details_title": "A few details",
  "tf.photo_hint": "Tip",
  "res.title": "AI results",
  "res.making": "AI is making it… 1 to 3 minutes.",
  "res.tweak": "Small change (optional)",
  "res.tweak_ph": "E.g. a blue background",
  "res.again": "Make another",
  "res.pick": "Tap a picture to use it in your ad.",
  "studio.title": "Designer studio",
  "studio.new": "New template",
  "studio.mine": "My templates",
  "studio.points": "Points",
  "studio.empty": "No templates yet.",
  "studio.not_designer": "The studio is for designers. Apply on your account page.",
  "studio.st.draft": "Draft",
  "studio.st.pending": "In review",
  "studio.st.changes": "Needs changes",
  "studio.st.approved": "Approved",
  "studio.st.rejected": "Rejected",
  "studio.st.archived": "Removed",
  "studio.sec_basics": "Basics",
  "studio.title_sw": "Name (Swahili)",
  "studio.title_en": "Name (English)",
  "studio.desc_sw": "Description (Swahili)",
  "studio.desc_en": "Description (English)",
  "studio.category": "Business type",
  "studio.kind": "Ad type",
  "studio.aspect": "Shape",
  "studio.sec_ai": "AI instructions",
  "studio.model": "Model",
  "studio.prompt": "Your instructions",
  "studio.prompt_hint": "Describe the scene, light and camera move. Tap a field to insert it.",
  "studio.negative": "Avoid (optional)",
  "studio.duration": "Seconds",
  "studio.audio": "Add sound",
  "studio.cost": "AI cost per result: {usd}",
  "studio.sec_inputs": "What the customer gives",
  "studio.photos_min": "Photos, at least",
  "studio.photos_max": "Photos, at most",
  "studio.photo_hint_sw": "Photo tip (Swahili)",
  "studio.photo_hint_en": "Photo tip (English)",
  "studio.core": "Business details",
  "studio.fields": "Your questions",
  "studio.add_field": "Add a question",
  "studio.field_key": "Short name (for instructions)",
  "studio.field_sw": "Question (Swahili)",
  "studio.field_en": "Question (English)",
  "studio.required": "Required",
  "studio.sec_overlay": "Text on the picture",
  "studio.overlay_none": "None, AI picture only",
  "studio.overlay_hint": "Name, price and phone are set exactly with this layout.",
  "studio.accent": "Colour",
  "studio.sec_media": "Example pictures",
  "studio.cover": "Cover",
  "studio.examples": "Examples (trends)",
  "studio.upload": "Upload",
  "studio.sec_test": "Try it",
  "studio.test_photo": "Add a test photo",
  "studio.run": "Run a test",
  "studio.tests_left": "{n} tests left today",
  "studio.add_example": "Use as example",
  "studio.sandbox_note": "Sandbox: the result is just your photo.",
  "studio.save": "Save",
  "studio.submit": "Submit for review",
  "studio.saved": "Saved",
  "studio.submitted": "Sent for review",
  "studio.review_note": "Reviewer note",
  "studio.archive": "Remove template",
  "studio.ledger": "Points history",
  "studio.sales": "{n} sales",
  "studio.worth": "About {tsh}",
  "pts.template_approved": "Template approved",
  "pts.template_sale": "Template sale",
  "pts.payout": "Payout",
  "pts.adjust": "Adjustment",
  "err.template_not_found": "This template does not exist.",
  "err.template_locked": "This template is in review and cannot be changed now.",
  "err.bad_placeholder": "The instructions use an unknown field: {x}",
  "err.test_limit": "You have used today’s tests.",
  "err.cannot_rate_own": "You cannot rate your own template.",
  "err.missing_fields": "Fill in all required fields.",
  "err.forbidden": "You do not have access.",
  "err.not_ready": "The template is not complete: {x}",
  "err.service_paused": "This service is paused for a moment. Please try again later.",
  'err.network': 'No connection. Check your data and try again.',
  'err.server_error': 'Something went wrong on our side. Please try again shortly.',
  'err.order_not_found': 'This order does not exist. Check your link.',
  'err.photo_read': 'This photo could not be read. Try another one.',
  'nav.create': "Create",
  'nav.discover': "Discover",
  'nav.me': "Me",
  'disc.photo': "AI photo",
  'disc.video': "Video",
  'disc.ad': "Business ad",
  'disc.tools': "All",
  'disc.new': "NEW",
  'disc.make': "Make it",
  'disc.make_video': "Make video",
  'disc.pick': "Pick",
  'push.ready_title': "Tangazo: it's ready!",
  'push.ready_body': "Your picture is finished. Tap to see and download it.",
  'push.preview_title': "Tangazo: check the first frame",
  'push.preview_body': "The first frame is ready. Tap to check it and carry on.",
  'push.failed_title': "Tangazo: it failed",
  'push.failed_body': "It failed. Your tokens have been returned.",
  'push.wait_title': "Please wait, your picture is being made…",
  'push.wait_body': "It can take a few minutes. You can close this page: we will notify you when it is ready.",
  'push.enable': "Notify me when it's ready",
  'push.enabled': "We will notify you when it's ready",
  'push.denied': "Notifications are blocked in your browser. Allow them in the site settings.",
  'push.ios_hint': "On iPhone: tap Share, then \"Add to Home Screen\", and open Tangazo from there to get notifications.",
  'intro.purpose': "What are you making?",
  'intro.tone': "How should it feel?",
  'intro.tone_hint': "Pick one, or skip",
  'purpose.business': "A business ad",
  'purpose.business_desc': "Your product or service, with price and phone number",
  'purpose.meme': "Meme and fun",
  'purpose.meme_desc': "Something funny to share with friends",
  'purpose.personal': "For me",
  'purpose.personal_desc': "A picture or video of you, or of something you love",
  'purpose.other': "Something else",
  'purpose.other_desc': "Anything you want to make",
  'tone.funny': "Funny",
  'tone.beautiful': "Beautiful",
  'tone.dramatic': "Dramatic",
  'tone.natural': "Natural",
  'create.what_ph_personal': "Describe what you want, e.g. my cat as king of the street",
  'create.your_photo': "Your photo",
  'pay.personal_note': "Your picture is made by AI after you pay.",
  'pay.free': 'Or make a free picture',
  'pay.free_note': 'slower (2–5 min), basic quality',
  'done.title_personal': "Your picture is ready!",
  'intro.name': "Business name?",
  'intro.types': "What do you do?",
  'intro.types_hint': "Pick one or more",
  'intro.logo': "Got a logo?",
  'intro.logo_add': "Add logo",
  'intro.logo_hint': "Optional",
  'intro.step': "{n} of {total}",
  'intro.contacts': "Phone number?",
  'intro.contacts_hint': "Customers will call you here",
  'create.product_photo': "Product photo",
  'create.what_ph': "What should we make? e.g. An ad for new shoes",
  'ctx.add': "Add context",
  'ctx.add_more': "Add another",
  'ctx.name_ph': "Name, e.g. Colours",
  'ctx.value_ph': "Type it here",
  'ctx.remove': "Remove {name}",
  'ctx.ideas': "Ideas",
  'ctx.save': "Add",
  'ctx.cancel': "Cancel",
  'create.login_title': "Sign in first",
  'create.login_hint': "We keep your business and your ads safe.",
  'create.close': "Close",
  'create.title': "Create an ad",
  'create.templates': "Or start from a template",
  'create.tab_image': "Image",
  'create.tab_video': "Video",
  'create.tab_audio': "Audio",
  'create.mode': "New ad",
  'create.clear': "Start over",
  'create.clear_confirm': "Clear everything and start over?",
  'create.collapse': "Minimise",
  'create.expand': "Expand",
  'create.add_photos': "Add photos",
  'create.photos_hint': "Up to {max} photos",
  'create.desc_label': "Description",
  'create.desc_ph': "Describe what you sell or your offer, e.g. new women's shoes, all sizes",
  'create.packages': "Packages",
  'create.add_package': "Add a package",
  'create.pkg_name': "Package name",
  'create.pkg_name_ph': "e.g. 2 pairs",
  'create.pkg_price': "Price",
  'create.pkg_price_ph': "e.g. 60,000",
  'create.pkg_desc': "Description",
  'create.pkg_desc_ph': "e.g. Best value",
  'create.pkg_remove': "Remove package",
  'create.q_business': "What is your business called?",
  'create.q_phone': "Which number should customers call?",
  'create.next': "Next",
  'create.skip': "Skip",
  'create.edit': "Edit",
  'create.thinking': "The AI is looking at your photos…",
  'create.need_photo_q': "Add a photo and the AI will ask a few questions about it.",
  'create.all_set': "All set! Press Create.",
  'create.quality': "Quality",
  'create.q_standard': "Standard",
  'create.q_high': "High (2K)",
  'create.cost_1': "1 token per image",
  'create.cost_2': "2 tokens per image",
  'create.size': "Size",
  'create.model': "Model",
  'create.model_auto': "Best (auto)",
  'create.video_type': "Video type",
  'create.create': "Create",
  'create.creating': "Writing…",
  'create.tokens_est': "About {n} tokens",
  'create.tokens_note': "Tokens come from the package you pay for. Writing the words is free.",
  'create.audio_soon': "Audio ads are coming soon.",
  'create.need_photo': "Add at least one photo.",
  'create.uploading': "Uploading…",
  'err.need_business': 'Enter the business name.',
  'err.need_offer': 'Enter what you sell or your offer.',
  'err.bad_phone': 'Enter a valid phone number, e.g. 0712 345 678.',
  'err.missing_details': 'Fill in the business name, what you sell and the phone number.',
  'err.no_photos': 'Add at least one photo.',
  'err.too_large': 'The file is too large.',
  'err.not_an_image': 'This file is not a photo. Use JPG, PNG or WebP.',
  'err.too_many': 'Too many tries. Wait a little and try again.',
  'err.free_limit': "You've used today's free pictures. Try tomorrow, or pay for a better picture.",
  'err.free_unavailable': 'Free pictures are not available right now.',
  'err.locked': 'This order is paid and can no longer be changed.',
  'err.already_paid': 'This order is already paid.',
  'err.cancelled': 'This order was cancelled.',
  'err.bad_product': 'Choose a package.',
  'err.payment_unavailable': 'Payments are not available right now. Please try again shortly.',
  'err.no_pending_payment': 'There is no payment waiting.',
  'err.voucher_not_found': 'This voucher does not exist. Check the code.',
  'err.voucher_expired': 'This voucher has expired.',
  'err.voucher_used': 'This voucher has been fully used.',
  'err.voucher_wrong_kind': 'This voucher is for image ads only.',
  'err.not_eligible': 'This is not possible for this order.',
  'err.script_needed': 'Confirm the video plan first.',
  'err.script_empty': 'Write the video description and at least one scene.',

  'ad.call': 'Call',
  'ad.offer_word': 'Offer',
  'ad.credit': 'Ad made with {site}',

  'v2.balance': 'Balance: {n} tokens',
  'v2.buy_tokens': 'Buy tokens',
  'v2.price': 'Price: {n} tokens (TSh {tzs})',
  'v2.price_from': 'from {n} tokens',
  'v2.tokens': '{n} tokens',
  'v2.tsh': 'TSh {tzs}',
  'v2.quality': 'Quality',
  'v2.q.kawaida': 'Standard',
  'v2.q.hd': 'HD',
  'v2.q.premium': 'Premium',
  'v2.duration': 'Length',
  'v2.seconds': '{s} seconds',
  'v2.addons': 'Add',
  'v2.addon_price': '+ {n} tokens',
  'v2.addon_free': 'free on your plan',
  'v2.total': 'Total',
  'v2.use': 'Use this template',
  'v2.free_badge': 'Free fixes: {n}',
  'v2.upload': 'Upload your photo',
  'v2.upload_more': 'Photo {n} of {max}',
  'v2.consent': 'I confirm this is my photo or I have permission to use it',
  'v2.script': 'Ad script',
  'v2.script_hidden': 'This template writes its own script.',
  'v2.final_prompt': 'Full instructions (English)',
  'v2.improve': 'Improve with AI ({n} free)',
  'v2.improve_paid': 'Improve with AI ({n} tokens)',
  'v2.narration_count': '~{s} / {max} seconds',
  'v2.next': 'Continue',
  'v2.confirm': 'Confirm — {n} tokens (TSh {tzs})',
  'v2.promo': 'Have a promo code?',
  'v2.promo_apply': 'Apply',
  'v2.generating': 'Making it…',
  'v2.generating_step': 'Making the {step}…',
  'v2.step.first_frame': 'first frame',
  'v2.step.video': 'video',
  'v2.step.image': 'image',
  'v2.step.photos': 'photos',
  'v2.preview': 'Check the first frame',
  'v2.preview_lead': 'If you like it, go on to the video. If not, fix it first.',
  'v2.continue_video': 'Continue to the video',
  'v2.free_iter': 'Free fixes: {used} of {total}',
  'v2.iterate_free': 'Fix it for free',
  'v2.retry': 'Try again — {n} tokens ({pct}% off)',
  'v2.iter_window': 'You can fix it until {time}',
  'v2.download': 'Download',
  'v2.share': 'Share on WhatsApp',
  'v2.sizes': 'Other sizes',
  'v2.size.9:16': 'Status / Reels',
  'v2.size.1:1': 'Square post',
  'v2.size.4:5': 'Tall post',
  'v2.caption': 'Post caption',
  'v2.copy': 'Copy',
  'v2.short': 'You don’t have enough tokens. You need {n} more.',
  'v2.pay_custom': 'Pay TSh {tzs} now (change: {n} tokens)',
  'v2.pay_pack': '{name}: {tokens} tokens for TSh {tzs}',
  'v2.better_value': 'Better value',
  'v2.pay_phone': 'Phone number to pay with',
  'v2.pay_wait': 'Confirm the payment on your phone. Once it arrives we carry on by ourselves.',
  'v2.pay_done': 'Payment received. {n} tokens added.',
  'v2.pay_failed': 'The payment did not go through. Try again.',
  'v2.expires': 'Expire {date}',
  'v2.never_expires': 'Never expire',
  'v2.failed': 'It failed. Your tokens have been returned.',
  'v2.popular': 'Popular',
  'v2.watermark_note': 'Results paid with free tokens carry the Tangazo mark.',
  'v2.cancel': 'Cancel',
  'v2.cancelled': 'Cancelled. Unused tokens have been returned.',
  'v2.abandoned': 'Timed out. Unused tokens have been returned.',
  'v2.state.draft': 'Draft',
  'v2.state.quoted': 'Waiting for payment',
  'v2.state.held': 'Started',
  'v2.state.running': 'In progress',
  'v2.state.awaiting_approval': 'Check',
  'v2.state.succeeded': 'Ready',
  'v2.state.failed': 'Failed',
  'v2.state.cancelled': 'Cancelled',
  'v2.state.abandoned': 'Abandoned',
  'v2.login_first': 'Sign in first to use tokens.',
  'v2.sandbox': 'Test mode: the result is your own photo.',

  'wallet.title': 'My tokens',
  'wallet.lots': 'Your tokens',
  'wallet.lot': '{n} tokens · {when}',
  'wallet.held': '{n} tokens in use right now',
  'wallet.expiring': '{n} tokens expire soon',
  'wallet.history': 'History',
  'wallet.packs': 'Token packs',
  'wallet.pack_line': '{tokens} tokens · {days} days',
  'wallet.bonus': '+{pct}% bonus',
  'wallet.buy': 'Buy',
  'wallet.plans': 'Business plans',
  'wallet.plan_line': '{tokens} tokens a month · TSh {tzs}/month',
  'wallet.plan_active': 'Your plan: {name} · until {date}',
  'wallet.plan_grace': 'Your plan has ended. Pay before {date} to keep it.',
  'wallet.subscribe': 'Subscribe',
  'wallet.feature.brand_kit': 'Your logo and business details on every ad',
  'wallet.feature.captions_free': 'Free post captions',
  'wallet.feature.extra_sizes_free': 'Free extra sizes',
  'wallet.feature.priority_queue': 'Priority in the queue',
  'wallet.feature.client_folders': 'Client folders',
  'wallet.feature.white_label': 'Your logo instead of Tangazo',
  'wallet.brand': 'Business details (brand kit)',
  'wallet.brand_name': 'Business name',
  'wallet.brand_phone': 'Phone number',
  'wallet.brand_location': 'Location',
  'wallet.brand_saved': 'Saved',
  'wallet.referral': 'Invite a friend',
  'wallet.referral_lead': 'When a friend first buys TSh {min} or more of tokens, you both get {n} tokens.',
  'wallet.referral_stats': 'Invited {invited} · paid {rewarded}',
  'wallet.referral_share': 'Join Tangazo and make ads on your phone: {link}',
  'wallet.l.credit': 'Added',
  'wallet.l.hold': 'Set aside for an ad',
  'wallet.l.capture': 'Spent',
  'wallet.l.release': 'Returned',
  'wallet.l.expire': 'Expired',
  'wallet.l.adjust': 'Adjustment',
  'wallet.src.pack': 'Pack',
  'wallet.src.plan': 'Plan',
  'wallet.src.custom_topup': 'Top-up',
  'wallet.src.signup_bonus': 'Welcome gift',
  'wallet.src.referral': 'Referral gift',
  'wallet.src.promo': 'Promo',
  'wallet.src.legacy': 'Old balance',
  'wallet.src.adjust': 'Adjustment',
  'wallet.empty': 'You have no tokens yet.',

  'err.insufficient_tokens': 'You don’t have enough tokens.',
  'err.feature_off': 'This is not switched on yet.',
  'err.job_not_found': 'This ad does not exist.',
  'err.consent_required': 'Confirm you have permission to use this photo.',
  'err.content_blocked': 'We can’t make this. Change the text or the photo. No tokens were taken.',
  'err.price_changed': 'The price changed. Check the new price and confirm again.',
  'err.quote_expired': 'The price expired. Confirm again.',
  'err.bad_quote': 'The price is not valid. Try again.',
  'err.requote': 'The script changed. Check the new price, then confirm.',
  'err.not_awaiting_approval': 'This step is not waiting for approval.',
  'err.not_iterable': 'This can’t be fixed right now.',
  'err.iteration_window_over': 'The time to fix it is over.',
  'err.retry_payment_required': 'Your free fixes are used up.',
  'err.promo_invalid': 'This promo code doesn’t work.',
  'err.promo_used': 'This promo code has been used.',
  'err.promo_wrong_kind': 'This promo code is for something else.',
  'err.promo_first_video_only': 'This offer is for your first video only.',
  'err.pack_not_found': 'This pack does not exist.',
  'err.plan_not_found': 'This plan does not exist.',
  'err.bad_amount': 'Choose an amount.',
  'err.use_tokens': 'This ad is paid with tokens.',
  'err.cannot_cancel': 'It can’t be cancelled now.',
  'err.empty_field': 'Write something first.',
  'err.bad_field': 'This field can’t be improved.',
  'err.ai_unavailable': 'AI is not available right now. Try again later.',
  'err.bad_output': 'Choose a photo.',
  'err.unknown_quality': 'Choose a quality.',
  'err.bad_duration': 'Choose a length.',
  'err.addon_not_allowed': 'This add-on is not available for this template.',
  'err.unavailable': 'This template is not available right now.',
};

export const STRINGS: Record<Lang, Strings> = { sw, en };

// Returns the text for `key` in `lang` (falling back to Swahili, then the key itself).
// Arrays (feature lists) are returned as they are.
export function translate(lang: string, key: string, vars?: Record<string, string | number>): string | string[] {
  const v = STRINGS[lang as Lang]?.[key] ?? STRINGS.sw[key] ?? key;
  if (typeof v !== 'string' || !vars) return v;
  return v.replace(/\{(\w+)\}/g, (m, k: string) => String(vars[k] ?? m));
}
